import { GenericColorMapping } from '@/components/ui/charts/ColorMapping';

export default function getColorByTraceKey(key) {
  if (GenericColorMapping.hasOwnProperty(key)) {
    return GenericColorMapping[key];
  }
  return GenericColorMapping.default;
}
